import { SVGProps } from 'react'

export const GuidesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 15.5001C11.8486 14.3117 13.2871 13.9142 15.1342 13.7812C16.3335 13.6949 16.9332 13.6517 17.3298 13.4238C17.696 13.2134 17.9509 12.9394 18.1345 12.5591C18.3334 12.1471 18.3334 11.6029 18.3334 10.5144V2.16675C14.6297 2.16675 12.7778 2.16675 10 3.95246M10 15.5001C8.15146 14.3117 6.71296 13.9142 4.86585 13.7812C3.66651 13.6949 3.06684 13.6517 2.67024 13.4238C2.30404 13.2134 2.0491 12.9394 1.86551 12.5591C1.66669 12.1471 1.66669 11.6029 1.66669 10.5144V2.16675C5.37039 2.16675 7.22224 2.16675 10 3.95246M10 15.5001V3.95246M17.5 16.7501C14.1667 16.7501 12.5 17.1668 10 18.8334C7.50002 17.1668 5.83335 16.7501 2.50002 16.7501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
